import { FC, useState } from 'react';
import { AllieSegmentProps, AllieText } from '../../../components';
import { LoginPin, LoginPinProps } from '../LoginPin';
import { LoginEmail, LoginEmailProps } from '../LoginEmail';
import { AllieSegment } from '../../../components/Segments/Segment';
import { StyledLoginEmailPin } from './LoginEmailPin.styles';
import { AllieAlertCircleOutlineIcon } from '../../../styling/icons';
import { isMobile } from '../../../common/utils';

export interface LoginEmailPinProps {
  pinProps: LoginPinProps;
  emailProps: LoginEmailProps;
  pinLabel: string;
  emailLabel: string;
  infoWarning?: {
    show?: boolean;
    message: string;
  };
  pinEnabled?: boolean;
}

export const LoginEmailPin: FC<LoginEmailPinProps> = ({
  pinProps,
  emailProps,
  pinLabel,
  emailLabel,
  infoWarning,
  pinEnabled,
}) => {
  const [segment, setSegment] = useState<'pin' | 'email'>(pinEnabled ? 'pin' : 'email');
  const handleSegmentChange = (e: any) => {
    setSegment(e.detail.value);
  };

  const propSegment: AllieSegmentProps = {
    onIonChange: handleSegmentChange,
    options: [
      {
        value: 'pin',
        text: pinLabel,
      },
      {
        value: 'email',
        text: emailLabel,
      },
    ],
    style: { marginBottom: '16px' },
    value: segment,
  };

  const messageInfoWarning = (
    <div
      style={{
        marginBottom: '12px',
        display: 'flex',
        columnGap: '8px',
        color: 'var(--allie-color-error-70)',
        textAlign: 'left',
      }}
    >
      <AllieAlertCircleOutlineIcon size="large" />
      <div style={{ flex: '1 1' }}>
        <AllieText color="error-70">{infoWarning?.message}</AllieText>
      </div>
    </div>
  );

  return (
    <StyledLoginEmailPin>
      {pinEnabled && <AllieSegment {...propSegment} />}
      <div>
        {infoWarning?.show && messageInfoWarning}
        {segment === 'pin' ? (
          <LoginPin {...pinProps} showClose={false} />
        ) : (
          <LoginEmail
            {...emailProps}
            onCancel={pinProps.onCancel}
            labelCancel={pinProps.labelCancel}
            style={{ width: isMobile ? 'auto' : 476 }}
          />
        )}
      </div>
    </StyledLoginEmailPin>
  );
};
